import { EAppointmentType, EServiceGroup } from "@constants";
import { ICart } from "@features/cart/ICart";
import { hasOfferBroadband, selectOfferInCartByServiceGroup } from "@utils/offerUtils";

/**
 * Validates if the Payment step can be accessed
 * Checks:
 * - If broadband offer in cart and not preorder:
 *   - Appointment must exist
 *   - If FULL_INSTALL: installation date must be filled
 *   - If NO_INSTALL (SELF_INSTALL): activation date must be filled
 */
export const isPaymentStepValid = (cart: ICart): boolean => {
    if (hasOfferBroadband(cart.offers)) {
        const broadbandOffer = selectOfferInCartByServiceGroup(cart, EServiceGroup.SA_BB);
        if (broadbandOffer) {
            const isPreOrder = broadbandOffer.prequal?.isPreOrder;

            // If it's a preorder, no need to check dates
            if (!isPreOrder) {
                // If appointment is null or undefined, it's invalid
                if (!broadbandOffer.appointment) {
                    return false;
                }

                const appointmentType = broadbandOffer.appointment.type;

                // If FULL_INSTALL, check that appointment.at is filled
                if (appointmentType === EAppointmentType.FULL_INSTALL) {
                    if (!broadbandOffer.appointment.at) {
                        return false;
                    }
                } else if (appointmentType === EAppointmentType.NO_INSTALL) {
                    // If NO_INSTALL (SELF_INSTALL), check that activationAt is filled
                    if (!broadbandOffer.activationAt) {
                        return false;
                    }
                } else {
                    // If appointmentType is not defined or has another value, it's invalid
                    return false;
                }
            }
        }
    }

    return true;
};
